"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var spel2js_1 = require("spel2js");
var Either_1 = require("fp-ts/lib/Either");
var getCompiledExpression = function (expression) {
    return (0, Either_1.tryCatch)(function () {
        return spel2js_1.SpelExpressionEvaluator.compile(expression);
    }, function (e) { return e; });
};
exports.default = getCompiledExpression;
//# sourceMappingURL=getCompiledExpression.js.map